import React from 'react';
import ReactDOM from 'react-dom';

import BackendService from './services/BackendService';
import AnalyticsService from './services/AnalyticsService';
import Loading from './components/Loading';
import HeaderInfo from './components/HeaderInfo';
import AdList from './components/AdList';

import './reset.css';
import { Container } from './styles';

class App extends React.Component {

  phoneNumber;

  constructor() {
    super();
    this.phoneNumber = this.getUrlParams(window.location)['p'];
  }

  componentDidMount = async () => {
    AnalyticsService.sendPageView();
    if (!this.phoneNumber) {
      this.setState({ backendData: [] });
      return;
    };
    const data = await BackendService.fetch(this.phoneNumber);
    this.setState({ backendData: data });
  }

  render = () => {
    let view = <Loading />;
    if (this.state && this.state.backendData) {
      view = 
        <Container>
          <HeaderInfo adNum={this.state.backendData.length} />
          <AdList
            ads={this.state.backendData}
            phoneNumber={this.phoneNumber} />
        </Container>;
    }
    return view;
  }

  getUrlParams = (url) => {
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };
}

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js